import type {
  OutfitRecommendation,
  RecommendationRequest,
  RecommendationsResponse,
  WearLog,
  WearLogsResponse,
} from '../../shared/recommendations';
import { readError } from './api';

export async function getRecommendations(
  input: RecommendationRequest,
): Promise<RecommendationsResponse> {
  const response = await fetch('/api/recommendations', {
    method: 'POST',
    credentials: 'include',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  if (!response.ok) throw new Error(await readError(response));
  return (await response.json()) as RecommendationsResponse;
}

export async function getWearLogs(): Promise<WearLog[]> {
  const response = await fetch('/api/wear', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error(await readError(response));
  return ((await response.json()) as WearLogsResponse).logs;
}

export async function wearToday(
  recommendation: OutfitRecommendation,
  occasion: RecommendationRequest['occasion'],
  mood: RecommendationRequest['mood'],
): Promise<void> {
  const response = await fetch('/api/wear', {
    method: 'POST',
    credentials: 'include',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({
      garmentIds: recommendation.garments.map((garment) => garment.id),
      occasion,
      mood,
      wornOn: new Date().toISOString().slice(0, 10),
    }),
  });
  if (!response.ok) throw new Error(await readError(response));
}
